// import CableReady from 'cable_ready'
import consumer from './consumer'

consumer.subscriptions.create('FlashMessagesChannel', {
  received (data) {
    //console.log('FlashMessagesChannel | data', data)
    if (data.cableReady) CableReady.perform(data.operations, { emitMissingElementWarnings: false } )
  }
})
